<div class="date-range-box">
  <div class="dr-section-label">Date Range</div>

  @if (isR4) {
    <div class="dr-scope-hint">
      <mat-icon class="dr-scope-icon">info_outline</mat-icon>
      <span>Applies to Priority Labs, All Labs &amp; Vital Signs only</span>
    </div>
  }

  <!-- Applied badge -->
  @if (drApplied) {
    <div class="dr-applied">
      <span class="dr-applied-check">&#10003;</span>
      <span class="dr-applied-text">{{ drFmtShort(drRangeStart) }} &rarr; {{ drFmtShort(drRangeEnd) }}</span>
      <button class="dr-applied-x" (click)="drClear()">&times;</button>
    </div>
  }

  <!-- From / To chips -->
  <div class="dr-chips">
    <div class="dr-chip" [class.filled]="drRangeStart" [class.error]="startInputError">
      <span class="dr-chip-label">From</span>
      <input #startInput
        class="dr-chip-input"
        [value]="startInputVal"
        placeholder="MM/DD/YYYY"
        maxlength="10"
        (input)="formatDateInput($event)"
        (blur)="onStartInputCommit(startInput.value)"
        (keydown.enter)="startInput.blur()" />
      @if (startInputError) {
        <span class="dr-chip-error">{{ startInputError }}</span>
      }
    </div>
    <span class="dr-arrow">&rarr;</span>
    <div class="dr-chip" [class.filled]="drRangeEnd" [class.error]="endInputError">
      <span class="dr-chip-label">To</span>
      <input #endInput
        class="dr-chip-input"
        [value]="endInputVal"
        placeholder="MM/DD/YYYY"
        maxlength="10"
        (input)="formatDateInput($event)"
        (blur)="onEndInputCommit(endInput.value)"
        (keydown.enter)="endInput.blur()" />
      @if (endInputError) {
        <span class="dr-chip-error">{{ endInputError }}</span>
      }
    </div>
  </div>

  <!-- Mat Calendar -->
  <div class="dr-cal-wrap">
    <mat-calendar
      [selected]="selectedRange"
      [minDate]="minDate"
      [maxDate]="maxDate"
      (selectedChange)="onRangeChange($event)">
    </mat-calendar>
    <div class="dr-hint">{{ drHint }}</div>
  </div>

  <!-- Apply button -->
  <button class="dr-apply-btn" (click)="drApply()" [disabled]="!drRangeStart || !drRangeEnd || !!startInputError || !!endInputError">
    Apply Filter
  </button>
</div>
